import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import type { AccountInfo } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';
import { resolveActiveAccount } from './active-account';

// Part Coding matches the signed-in name against partCodingUsers.
// Admin Part Coding uses partCodingAdmins. The two lists are independent.
export function userHasPartCodingAccess(account: AccountInfo | null): boolean {
	if (!account) return false;

	const username = account.username.trim().toLowerCase();
	return environment.msalConfig.users.partCodingUsers.some(
		(user) => user.trim().toLowerCase() === username
	);
}

// Allows the Part Coding route only for names on partCodingUsers.
// Everyone else is redirected to the E-Filing page.
export const partCodingGuard: CanActivateFn = (): boolean | UrlTree => {
	const msalService = inject(MsalService);
	const router = inject(Router);

	if (userHasPartCodingAccess(resolveActiveAccount(msalService))) {
		return true;
	}

	return router.createUrlTree(['/']);
};
